
export const FETCH_KNOWN_FOR = 'FETCH_KNOWN_FOR'
export const FETCH_KNOWN_FOR_REQUEST = 'FETCH_KNOWN_FOR_REQUEST'
export const FETCH_KNOWN_FOR_SUCCESS = 'FETCH_KNOWN_FOR_SUCCESS'